import { FC, ReactNode } from "react";
import { Autocomplete, TextField } from "@mui/material";
import {
  createAutocompleteFieldFilter,
  getAutocompleteNoOptionsText,
  isOptionEqualByField,
} from "./autocompleteHelpers";
import { Supplier } from "../../../api/types";

interface SupplierAutocompleteFieldProps {
  id: string;
  value: Supplier | null;
  onChange?: (value: Supplier | null) => void;
  onBlur?: () => void;
  options?: Supplier[];
  isLoading?: boolean;
  width?: string;
  label?: string;
  name?: string;
  error?: boolean;
  helperText?: ReactNode;
}

const supplierFilter = createAutocompleteFieldFilter<Supplier>("supplierName");
const supplierComparator = isOptionEqualByField<Supplier>("supplierName");

const SupplierAutocompleteField: FC<SupplierAutocompleteFieldProps> = ({
  id,
  value,
  onChange,
  onBlur,
  options = [],
  isLoading = false,
  width = "25rem",
  label = "Supplier",
  name,
  error = false,
  helperText = "",
}) => {
  return (
    <Autocomplete
      noOptionsText={getAutocompleteNoOptionsText("Suppliers", isLoading)}
      id={id}
      value={value}
      onChange={(_e, option) => onChange?.(option)}
      onBlur={onBlur}
      disablePortal
      options={options}
      getOptionLabel={(option) => option?.supplierName ?? ""}
      filterOptions={supplierFilter}
      isOptionEqualToValue={supplierComparator}
      sx={{ width }}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          variant="outlined"
          size="small"
          margin="none"
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
      autoSelect
    />
  );
};

export default SupplierAutocompleteField;
